export default "__VITE_ASSET__4972d31a__"